import React from 'react';
import {
  string, array,
} from 'prop-types';
import Locale from '@active/react-utils/i18n/Locale';
import OrderLines from '../OrderLines';
import OrderLineTitle from '../OrderLineTitle';

const TransferGroups = ({
  transferPairList,
  currencyCode,
  orderLineFieldsConfig,
}) => {
  if (transferPairList.length === 0) {
    return null;
  }
  return (
    <div className="transfer-orderline-groups">
      <OrderLineTitle
        className="transfer-orderline-groups__title"
        descriptionTitleId={'checkout.lib.components.text.items'}
        amountTitleId={'checkout.lib.components.orderDetailContent.subTotal'}
        orderLineFieldsConfig={orderLineFieldsConfig}/>
      <div className="transfer-orderline-groups__content">
        {
          transferPairList.map(({
            transferOut: { orderLines: outOrderLines },
            transferIn: { orderLines },
          }, idx) => {
            return (
              <div key={idx} className="transfer-item">
                <div className="transfer-item__out">
                  <div className="transfer-item__out-title">
                    <div className="transfer-item__out-icon">
                      <i className="ic-out"/>
                    </div>
                    <div className="transfer-item__out-text">
                      <Locale id="checkout.lib.components.text.transferOut"/>
                    </div>
                  </div>
                  <div className="transfer-item__out-content">
                    <OrderLines
                      currencyCode={currencyCode}
                      orderLines={outOrderLines}
                      orderLineFieldsConfig={orderLineFieldsConfig}/>
                  </div>
                </div>
                <div className="transfer-item__in">
                  <div className="transfer-item__in-title">
                    <div className="transfer-item__in-icon">
                      <i className="ic-in"/>
                    </div>
                    <div className="transfer-item__in-text">
                      <Locale id="checkout.lib.components.text.transferIn"/>
                    </div>
                  </div>
                  <div className="transfer-item__in-content">
                    <OrderLines
                      orderLineFieldsConfig={orderLineFieldsConfig}
                      currencyCode={currencyCode}
                      orderLines={orderLines}/>
                  </div>
                </div>
              </div>
            );
          })
        }
      </div>
    </div>
  );
};

TransferGroups.propTypes = {
  transferPairList: array,
  currencyCode: string,
};

TransferGroups.defaultProps = {
  transferPairList: [],
};

export default TransferGroups;
